import { memo } from 'react';

import Stack from '@mui/material/Stack';

import { useAuthContext } from 'src/auth/hooks';
import { hasPermissions } from 'src/auth/guard/utils';
import NavList from './nav-list';
import { NavProps, NavGroupProps } from '../types';

// ----------------------------------------------------------------------

function NavSectionMini({ data, slotProps, ...other }: NavProps) {
  return (
    <Stack component="nav" id="nav-section-mini" spacing={`${slotProps?.gap || 4}px`} {...other}>
      {data.map((group, index) => (
        <Group key={group.subheader || index} items={group.items} slotProps={slotProps} />
      ))}
    </Stack>
  );
}

export default memo(NavSectionMini);

// ----------------------------------------------------------------------

function Group({ items, slotProps }: NavGroupProps) {
  const { user } = useAuthContext();

  const filteredItems = items
    .filter((item) => hasPermissions(user, item.permissions) && !hasPermissions(user, item.except));

  return <>{filteredItems.map((list) => (<NavList key={list.title} data={list} depth={1} slotProps={slotProps} />))}</>;
}
